import { render, staticRenderFns } from "./AcademyManager.vue?vue&type=template&id=09e2d89a&scoped=true&"
import script from "./AcademyManager.vue?vue&type=script&lang=js&"
export * from "./AcademyManager.vue?vue&type=script&lang=js&"
import style0 from "./AcademyManager.vue?vue&type=style&index=0&id=09e2d89a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09e2d89a",
  null
  
)

export default component.exports